/* eslint-disable multiline-ternary */
import React, { Fragment, useEffect, useRef } from 'react'
import { BrandProps } from './types'
import resolveProps from '../../utils/resolveProps'
import BrandFn from 'mondrian-vanilla/core/components/Brand/brand'

const config = {
  types: [
    {
      title: 'shape',
      isDefault: true
    },
  ],
  modifiers: [
    'sm',
    {
      title: 'md',
      isDefault: true
    },
    'lg'
  ],
  state: []
}

function Brand(props: BrandProps) {
  const { lg, md, sm, src, alt, ...rest } = props

  const rootElement = useRef( )

  useEffect(()=>{ 
    rootElement.current && BrandFn(rootElement.current)
   }, [rootElement])

  return (
    <div ref={rootElement} {...rest} className={resolveProps(props, config, 'Brand')} >
      <img className="mdn-Brand-image" src={src} alt={alt} />
    </div>
  )
}

export default Brand
